var code = {
    vote: {
        2001: "昵称不能为空",
        2002: "昵称没有变化",
        2003: "昵称超长",
        2004: "昵称已存在",
        2005: "头像不能为空",
        1001: "文本内容违规，请重新编辑",
        1002: "图片内容违规，请重新上传",
        1003: "主题已存在",
        1004: "帖子不存在",
        1005: "用户不存在",
        1006: "不能关注自己",
        1007: "评论不存在",
        1008: "话题不存在",
        1009: "图片最多上传100张",
        1010: "图片字段格式错误",
        1011: "话题不可用",
        1012: "因违反社区规范被禁言",
        1013: "因违反社区规范被封禁",
        1014: "禁用",
        1015: "操作速度太快了，请稍后再试试吧～",
        1016: "达到 10级 解锁",
        1017: "话题名称不符合规则",
        403: '没有身份验证',
        400: '昵称已存在',
        1021: "帖子不可评论",
        2006: "登录码获取失败",
        2007: "登录码已被绑定",
        2008: "登录码已其他微信绑定",
        2009: "登录码绑定不匹配",
        2010: "无登录码",
        2011: "登录码刷新频率太高",
        2012: "登录码错误",
        2900: "微信未授权",

        2020: "文章数不满足条件",
        2021: "粉丝数不满足条件",
        2022: "社区等级不满足条件",
        2023: "认证类型无效",
        2024: "存在认证申请",
        2025: "存在已通过认证申请",
        2026: "认证申请保存失败",
        2027: "不存在认证记录",
        2028: "取消认证未满15天",
        2029: "未认证",
        2030: "存在更换认证申请",

        2052: '该手机号已被绑定过',
        2055: '绑定码不存在或错误',
        2056: '该绑定码已经绑定，不能二次绑定',
        2050: "需要登录",
        2105: "当前未绑定游戏信息，请前往游戏内社区进行签到",
        "other": '异常错误：',
    }
}
export {
    code
}